import { SectionHeader } from "@/components/SectionHeader";
const PARAGRAPHS = [
  "Hotel rooms have become more sophisticated, but the technology behind them hasn’t always kept pace. Systems are pieced together, difficult to manage, and too often designed without enough consideration for the guest or the space around them.",
  "Somo started with a different point of view: technology should make the room more intuitive for guests, more manageable for teams, and more efficient for the property, while staying out of the way of the experience.",
  "So we built the hardware, software, and intelligence together, from the beginning, around the realities of hospitality.",
];

export function StorySection() {
  return (
    <section className="px-8 py-20 md:px-6 md:py-16 lg:py-32">
      <SectionHeader
        variant="split"
        className="mx-auto max-w-6xl"
        eyebrow="Our story"
        title="We thought hotel technology could work better."
        body={PARAGRAPHS.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      />
    </section>
  );
}
